<template>
  <b-card class="border-none">
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="dataLoad"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="dataLoad()"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="getAllCategory.result"
      border
    >
      <el-table-column
        label="Image"
        prop="image"
        min-width="100px"
        min-height="100px"
      >
        <template slot-scope="scope">
          <img :src="`${$imageURL}/${scope.row.image}`" alt="image" />
        </template>
      </el-table-column>
      <el-table-column
        label="Title"
        min-width="150px"
        prop="title"
        class="ml-12"
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.name }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Description" prop="description" min-width="150px">
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm ellipsis-4"
            v-html="row.description"
          ></p>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Podcast"
        prop="podcast_count"
        min-width="100px"
      >
        <template v-slot="{ row }">
          <p class="font-semibold name mb-0 text-sm text-center cursor-pointer">
            {{ row.podcast_count }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="150px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="Status"
        min-width="180px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <button
              v-if="scope.row.isActive"
              @click="PublishUnPublish(scope, false)"
              class="px-4 py-2 font-semibold bg-primary clr-fff rounded-lg"
            >
              unPublish
            </button>
            <button
              v-if="!scope.row.isActive"
              @click="PublishUnPublish(scope, true)"
              class="px-4 py-2 font-semibold bg-primary clr-fff rounded-lg"
            >
              Publish
            </button>
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      currentPage: 1,
      editModal: false,
      perPage: 5,
      search: "",
      totalPages: 0,
    };
  },
  watch: {
    // search: {
    //   handler: _.debounce(async function (val) {
    //     this.getAll();
    //     this.currentPage = 1;
    //   }, 500),
    // },
  },
  methods: {
    async dataLoad() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage * this.perPage,
        search: this.search,
      };

      await this.$store.dispatch("podcast/getall_category", payload);
      this.totalPages = this.getAllCategory.totalCount;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataLoad();
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$router.push({ name: "edit-podcast-category" });
      await this.$store.commit("podcast/SELECTED_CATEGORY", row);
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { categoryId: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("podcast/delete_category", payload);
        this.dataLoad();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async PublishUnPublish({ row }, isActive) {
      let payload = {
        _id: row._id,
        isActive,
      };

      await this.$store.dispatch("podcast/update_category", payload);
      this.dataLoad();
    },
  },
  computed: {
    ...mapState("podcast", { getAllCategory: "getAllCategory" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
